/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MFAVerify = {
    mfa_method: MFAVerify.mfa_method;
    mfa_code: string;
}

export namespace MFAVerify {

    export enum mfa_method {
        EMAIL = 'email',
        SMS = 'sms',
        APP = 'app',
    }


}
